module.exports = __webpack_public_path__ + "img/certificado-Barragan_2025.04ba94ab.jpg";